import React from 'react';
import { IStyledSVGIconProps, StyledSVGIcon } from './icon.style';

export const CustomArrowIcon: React.FC<IStyledSVGIconProps> = (props) => {
  return (
    <StyledSVGIcon
      width={props.width ? props.width : "14"}
      height={props.height ? props.height : "14"}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 5 6"
      {...props}
    >
      <path
        d="M2.85408 3L0 0V1.125L1.78112 3L0 4.875V6L2.85408 3Z"
        fill-opacity="0.56"
      />
      <path
        d="M5 3L2.14592 0V1.125L3.92704 3L2.14592 4.875V6L5 3Z"
        fill-opacity="0.56"
      />
    </StyledSVGIcon>
  );
};